<template>
  <el-card class="box-card">
    <div slot="header" class="card-head">
      <div>使用说明</div>
    </div>
  <PdfViewer url="/static/瑞家园管理系统操作手册(工厂端).pdf" :height="800"
  ></PdfViewer>
  </el-card>
</template>

<script>
import PdfViewer from '@/components/PdfViewer'
import FactoryPage from '@/views/modules/home/factory/index.vue'

export default {
  name: 'help-card',
  components: {
    PdfViewer
  },
}
</script>

<style scoped>

</style>
